type ConfigTypes = {
  placeholder: {
    timer: number; // ms timer for placeholder custom message
  };
};

export const Config: ConfigTypes = {
  placeholder: {
    timer: 5000,
  },
};
